import React, { Component } from "react";
import { PageHeader } from "react-bootstrap";
import { Panel,
          Row,
          Col,
          Button,
          FormGroup,
          Tabs,
          Tab,
          FormControl,
          ControlLabel,
          Table,
          Checkbox,
          Glyphicon,
          Modal,
          ButtonGroup,
          DropdownButton,
          MenuItem,
          Tooltip,
          OverlayTrigger,
          ListGroup,
          ListGroupItem,
          Image,
          Radio} from "react-bootstrap";
import Truncate from 'react-truncate';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import DatePicker from 'react-16-bootstrap-date-picker';//has min/maxDate but no time
import Datetime from 'react-datetime';//has time but no min/maxDate
import {ToastContainer, ToastStore} from 'react-toasts';
import moment from 'moment';
//Props:
//emailNotif
//emailNotifIndex
let onChangeTimeOut;
class EmailNotif extends Component {

  render() {
    const {emailNotifIndex, emailNotif} = this.props;
    let title = emailNotifIndex != null ? "" : "Add New Email";
    let titleColor = emailNotifIndex != null ? null : "#3c9979";

    return (<Row key={emailNotifIndex} style={{marginTop: 20}}>
                <Col>
                    <Row style={{}}>
                      <Col md={8} style={{textAlign: "left", fontSize: 14, bold: true, marginLeft: 30}}>
                        <Row>
                            <Col md={10} style={{textAlign: "left", color: titleColor}}>
                                {title}
                            </Col>
                            <Col md={2} style={{textAlign: "left"}}>
                              <Glyphicon glyph="trash" disabled={emailNotifIndex == null} className="pull-left col"
                                      style={{cursor: "pointer", marginTop: 10, textAlign: "left"}}
                                      onClick={()=>{
                                        this.props.deleteEmailNotif(emailNotifIndex);
                                      }}/>
                            </Col>

                        </Row>
                        <input type="text" style={{width: "100%", marginTop: 10}}
                          value={emailNotif ? emailNotif.email : ""}
                          disabled={emailNotifIndex != null}
                          onChange={(e)=>{
                              var newEmailNotif = emailNotif;
                              newEmailNotif["name"] = e.target.value;

                              this.props.onChangeEmailNotif(newEmailNotif, emailNotifIndex ? emailNotifIndex-1 : null);
                        }}/>
                      </Col>
                      <Col md={3} style={{justifyContent: "flex-end", fontSize: 14, color: titleColor, marginBottom: 10, marginTop: 0}}>
                        <Row style={{marginBottom: 10}}>{"Send Time"}</Row>

                        <Datetime
                          inputProps={{disabled: (emailNotifIndex != null)}}
                          dateFormat={false}
                          value={emailNotif ? emailNotif.sendTime : ""}
                          onChange={(e)=>{
                            var newEmailNotif = emailNotif;
                            newEmailNotif["sendTime"] = moment(e).format("h:mm A");

                            this.props.onChangeEmailNotif(newEmailNotif, emailNotifIndex ? emailNotifIndex-1 : null);
                          }}/>

                      </Col>
                    </Row>
                    {emailNotifIndex == null
                        ? <Row style={{marginRight: 50}}>
                              <Button className="dark-blue-btn pull-right"
                                    onClick={()=>{
                                      this.props.addEmailNotif(emailNotif)
                                    }}>
                                      Add Email
                                  </Button>
                          </Row>
                        : null}
                </Col>
          </Row>)
  }
}

export default EmailNotif;
